import { configureStore } from '@reduxjs/toolkit';
import { createShuttleMiddleware, createPulseMiddleware } from 'shuttle';
import createSagaMiddleware from 'redux-saga';

// Middleware for RTK Query
import { api } from 'services/api';

export const initializeStore = (
  appname,
  reducers,
  externalActions = {},
  sagaMiddleware = createSagaMiddleware()
) => {
  // Getting errors???
  // Pass in undefined for any optional parameters
  // Because if you pass in null to configureStore, it will use null as the value
  // The magic of default parameters in JS requires that you pass in undefined
  // If you pass in null, it will use null as the value
  if (externalActions === null || sagaMiddleware === null) {
    throw new Error('Pass in undefined for any optional parameters');
  }

  const store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) => [
      ...getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
      }).concat(api.middleware),
      createShuttleMiddleware(appname, externalActions),
      createPulseMiddleware(appname),
      sagaMiddleware,
    ],
  });

  return store;
};
